/** @jsxImportSource react */
import React from 'react';
import { useThemeLanguage } from '@/contexts/ThemeLanguageContext';
import { usePlatformStatus } from '@/contexts/PlatformStatusContext';
import { PlatformStatusCard } from './PlatformStatusCard';
import './MaintenanceView.css';

export interface MaintenanceViewProps {
  onRetry: () => void;
  onAdminAccess: () => void;
  onSignOut?: () => void;
  isRetrying?: boolean;
}

export function MaintenanceView({
  onRetry,
  onAdminAccess,
  onSignOut,
  isRetrying = false,
}: MaintenanceViewProps) {
  const { t } = useThemeLanguage();
  const { maintenanceMessage } = usePlatformStatus();

  return React.createElement(
    'div',
    { className: 'maintenance-view' },
    React.createElement(PlatformStatusCard, {
      variant: 'maintenance',
      message: maintenanceMessage,
      title: t('maintenance.title'),
      primaryAction: {
        label: t('maintenance.retry'),
        onClick: onRetry,
        loading: isRetrying,
      },
      secondaryAction: {
        label: t('maintenance.adminAccess'),
        onClick: onAdminAccess,
      },
      tertiaryAction: onSignOut
        ? {
            label: t('maintenance.signOut'),
            onClick: onSignOut,
          }
        : undefined,
    }),
  );
}
